//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import ProviderPaymentCreate from '@/views/Purchase/PchProviderPayment/PchProviderPaymentCreate'
import ProviderPaymentList from '@/views/Purchase/PchProviderPayment/PchProviderPaymentList'
import ProviderPaymentUpdate from '@/views/Purchase/PchProviderPayment/PchProviderPaymentUpdate'

//
export default {
    path: 'provider_payment',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'provider-payment-list',
            component: ProviderPaymentList,
        },
        {
            path: 'create',
            name: 'provider-payment-create',
            component: ProviderPaymentCreate,
            meta: {
                title: 'Crear pago de proveedor',
            },
        },
        {
            path: ':id',
            name: 'provider-payment-update',
            component: ProviderPaymentUpdate,
            meta: {
                title: 'Detalle de pago a proveedor',
            },
        },
    ],
    meta: {
        title: 'Pagos de proveedores',
    },
}
